const NON_HOST_VISIBLE_STUDIO_STATUSES = new Set(['ARCHIVED', 'OWNER_DELETED']);

/** Studios the host should still manage in calendar, services list, etc. */
export const isHostVisibleStudio = (studio) => {
  if (!studio) return false;
  const status = studio.status || 'ACTIVE';
  return !NON_HOST_VISIBLE_STUDIO_STATUSES.has(status);
};

export const filterHostVisibleStudios = (studios = []) =>
  studios.filter(isHostVisibleStudio);
